import { t } from "ttag";

export class MissingClientSecretError extends Error {
  constructor(message = t`Missing client secret`) {
    super(message);
    this.name = "MissingClientSecretError";
  }
}
